import { Controller } from '@hotwired/stimulus'

export default class ClipboardController extends Controller {
  static targets = [
    'textToCopy', // Container with innerHTML to copy
    'copy', // Button to click on to copy
    'tooltip' // Container to display when copying
  ];

  connect() {
    if (this.element.dataset.initialized) return;

    if (this.hasCopyTarget) {
      this.copyTarget.addEventListener('click', () => {
        navigator.clipboard.writeText(this.textToCopyTarget.dataset['text']);

        if (this.hasTooltipTarget) {
          this.tooltipTarget.classList.remove('d-none');

          setTimeout(() => {
            this.tooltipTarget.classList.add('d-none');
          }, 1000);
        }
      });

      this.element.dataset.initialized = 'true';
    }
  }
}
